<template>
	<div class="vertical-menu" :class="'menu'+currentIndex">
		<div class="menu-list">
			<span v-for="(item, index) in menuItems" :key="index"
				:class="{active: currentIndex === index}" @click="changePage(index)">
			</span>
		</div>
	</div>
</template>

<script>
import { eventBus } from '@/main.js'
export default {
  name: 'LeftMenu',
  props: {
    currentIndex: Number,
  },
  data() {
  	return {
  		menuItems: ['Home', 'Product', 'Component3', 'Kingstron', 'Component5'],
  	}
  },
  methods:{
	changePage(index) {
		eventBus.$emit('leftMenuClick',index);
	},
  }
}
</script>

<style lang="less">
@import '../assets/css/style';
@import '../assets/css/index';
.vertical-menu{
	.scale(138,966);
	.pos-a(0, 0, 5);
	&.menu0{
		  background: url('../../static/nav-1.png');
		  background-size: 138/@r 966/@r;
	}
	&.menu1{
		  background: url('../../static/nav-2.png');
		  background-size: 138/@r 966/@r;
	}
	&.menu2{
		  background: url('../../static/nav-3.png');
		  background-size: 138/@r 966/@r;
	}
	&.menu3{
		  background: url('../../static/nav-4.png');
		  background-size: 138/@r 966/@r;
	}
	&.menu4{
		  background: url('../../static/nav-5.png');
		  background-size: 138/@r 966/@r;
	}
}	
.menu-list {
  position: absolute;
  top: 265/@r;
  left: -5/@r;
  // transform: translateY(-50%);
  width: 86/@r;
  display: flex;
  justify-items: center;
  flex-direction: column;
  z-index: 10;
 
  span{
	  width: 40/@r;
	  height: 40/@r;
	  margin: 0 auto 5/@r;
	  border-radius: 50%;
	  display: inline-block;
	  // &.active-menu-icon {
	  //   background-color: transparent;
	  // }
	  // &.active{
		 //  width: 20/@r;
		 //  height: 20/@r;
		 //  border: 4/@r solid #fff;
		 //  background-color: transparent;
	  // }
  }
  ul {
    list-style: none;
    li {
      margin-bottom: 8/@r;
      a {
        color: #000;
        .menu-icon {
          display: inline-block;
          width: 10/@r;
          height: 10/@r;
          margin-right: 10/@r;
          border-radius: 50%;
          background-color: #fff;
          border: 1/@r solid #000;
          &.active-menu-icon {
            background-color: transparent;
          }
        }
      }
    }
  }
}
</style>
